import "./Pages.css";
import {
  useState,
  useRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../../StateManagement/actions";
const Pages = forwardRef(function Pages({ docPages, isEdit }, ref) {
  const pageNumbersRef = useRef([]);
  const selectAllRef = useRef();
  const selectedInputRef = useRef([]);
  const [search, setSearch] = useState("");
  const [showPageNumbers, setShowNumbers] = useState(true);
  const pageNumbers = Array.from({ length: docPages }, (_, index) => index + 1);
  const className = showPageNumbers ? "tiltexpanded" : "tilt-icon";
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const prevSelectedPages = useRef([]);
  const [
    prevPagesToBeDisabledAnotherRestrictions,
    setPrevPagesToBeDisabledAnotherRestrictions,
  ] = useState([]);

  const checkPages = useRef([]);
  const results = useMemo(() => {
    return pageNumbers.filter((reader) =>
      JSON.stringify(reader).toLowerCase().includes(search.toLowerCase())
    );
  }, [search]);

  useEffect(() => {
    let count = 0;
    console.log(results);

    selectedInputRef.current.map((el) => {
      if (el) {
        el.checked = false;
        el.disabled = false;
      }
    });
    pageNumbersRef.current.map((element, i) => {
      if (element) {
        element.style.opacity = "100%";
        element.style.cursor = "pointer";
      }
    });

    pageSelection(
      prevSelectedPages.current,
      prevPagesToBeDisabledAnotherRestrictions
    );

    checkPages.current.forEach((page) => {
      if (results.includes(page)) {
        selectedInputRef.current[page].checked = true;
      }
    });

    selectedInputRef.current.map((el) => {
      if (el && el.checked) count++;
    });
    if (count > 0 && count === results.length) {
      selectAllRef.current.checked = true;
    } else {
      selectAllRef.current.checked = false;
    }
  }, [results]);

  const onSearchHandler = (event) => {
    setSearch(event.target.value);
    console.log(checkPages);
  };

  const selectPageHandler = () => {
    let flag = true;
    selectedInputRef.current.map((item) => {
      if (item) {
        flag = flag ? item.checked : flag;
      }
    });
    if (!flag) {
      selectAllRef.current.checked = false;
    } else {
      selectAllRef.current.checked = true;
    }
    const selectedInputs = selectedInputRef.current
      .map((element, i) =>
        element && element.checked && !element.disabled ? i : null
      )
      .filter((i) => i !== null);
    const selectedPages = pageNumbers.filter((num) =>
      selectedInputs.includes(num)
    );

    const unSelectedInputs = selectedInputRef.current
      .map((element, i) =>
        element && !element.checked && !element.disabled ? i : null
      )
      .filter((i) => i !== null);
    const unSelectedPages = pageNumbers.filter((num) =>
      unSelectedInputs.includes(num)
    );
    prevSelectedPages.current = prevSelectedPages.current.filter((page) => {
      return !unSelectedPages.includes(page);
    });

    const filteredSelectedRecords = checkPages.current.filter(
      (element) => !unSelectedPages.includes(element)
    );
    const filtered = selectedPages.filter(
      (page) => !checkPages.current.includes(page)
    );
    checkPages.current = [...filtered, ...filteredSelectedRecords];
  };

  useImperativeHandle(ref, () => {
    return {
      getSelection() {
        console.log(checkPages);
        console.log(prevSelectedPages);
        if (isEdit) {
          return [
            ...new Set([...checkPages.current, ...prevSelectedPages.current]),
          ];
        } else return [...checkPages.current];
      },
      doSelectionandDisable(
        selectedPages,
        pagesToBeDisabledAnotherRestrictions
      ) {
        prevSelectedPages.current = [...selectedPages];
        setPrevPagesToBeDisabledAnotherRestrictions([
          ...pagesToBeDisabledAnotherRestrictions,
        ]);
        pageSelection(selectedPages, pagesToBeDisabledAnotherRestrictions);
      },
      resetSelection(
        selectedPages,
        pagesToBeDisabledAnotherRestrictions
      ) {
        checkPages.current = [];
        prevSelectedPages.current = [...selectedPages];

        setPrevPagesToBeDisabledAnotherRestrictions([
          ...pagesToBeDisabledAnotherRestrictions,
        ]);
        selectedInputRef.current.forEach((element) => {
          if (element) {
            element.checked = false;
            element.disabled = false;
            element.style.cursor = "pointer";
          }
        });

        pageNumbersRef.current.forEach((element) => {
          if (element) {
            element.style.opacity = "100%";
            element.style.cursor = "pointer";
          }
        });
        pageSelection(
          selectedPages,
          pagesToBeDisabledAnotherRestrictions
        );
      },
    };
  });

  function pageSelection(selectedPages, pagesToBeDisabledAnotherRestrictions) {
    if (selectedPages && selectedPages.length > 0) {
      if (isEdit) {
        selectedPages.forEach((page) => {
          selectedInputRef.current.map((element, i) => {
            if (element && i == page) {
              element.checked = true;
              element.disabled = false;
            }
          });
          pageNumbersRef.current.map((element, i) => {
            if (element && i == page) {
              element.style.opacity = "100%";
              element.style.cursor = "pointer";
            }
          });
        });
        if (pagesToBeDisabledAnotherRestrictions) {
          pagesToBeDisabledAnotherRestrictions.forEach((page) => {
            selectedInputRef.current.map((element, i) => {
              if (element && i == page) {
                element.checked = true;
                element.disabled = true;
                element.style.cursor = "not-allowed";
              }
            });
            pageNumbersRef.current.map((element, i) => {
              if (element && i == page) {
                element.style.opacity = "50%";
                element.style.cursor = "not-allowed";
              }
            });
          });
        }
      } else {
        selectedPages.forEach((page) => {
          selectedInputRef.current.map((element, i) => {
            if (element && i == page) {
              element.checked = true;
              element.disabled = true;
            }
          });
          pageNumbersRef.current.map((element, i) => {
            if (element && i == page) {
              element.style.opacity = "50%";
              element.style.cursor = "not-allowed";
            }
          });
        });
      }
      let count = 0;
      selectedInputRef.current.map((el) => {
        if (el && el.checked) count++;
      });
      if (count > 0 && count === results.length) {
        selectAllRef.current.checked = true;
      } else {
        selectAllRef.current.checked = false;
      }
    }
  }


  const selectAllPagesHandler = (e) => {
    selectedInputRef.current.map((page, i) => {
      if (page && !page.disabled) {
        page.checked = e.target.checked;
      }
    });
    const selectedInputs = selectedInputRef.current
      .map((element, i) =>
        element && element.checked && !element.disabled ? i : null
      )
      .filter((i) => i !== null);
    const selectedPages = pageNumbers.filter((num) =>
      selectedInputs.includes(num)
    );

    const unSelectedInputs = selectedInputRef.current
      .map((element, i) =>
        element && !element.checked && !element.disabled ? i : null
      )
      .filter((i) => i !== null);
    const unSelectedPages = pageNumbers.filter((num) =>
      unSelectedInputs.includes(num)
    );
    prevSelectedPages.current = prevSelectedPages.current.filter((page) => {
      return !unSelectedPages.includes(page);
    });
    const filteredSelectedRecords = checkPages.current.filter(
      (element) => !unSelectedPages.includes(element)
    );
    const filtered = selectedPages.filter(
      (page) => !checkPages.current.includes(page)
    );
    checkPages.current = [...filtered, ...filteredSelectedRecords];
  };

  return (
    <div className="col-sm-12 col-md-2 pagesList">
      <table
        className=" table tablelayout scrolldown "
        cellPadding="0"
        cellSpacing="0"
        style={{ width: "100%" }}>
        <thead className="bg-lightblue">
          <tr style={{ width: "100%" }}>
            <th style={{ padding: "0.5rem" }}>
              <span
                className="me-3 font-16 page-font"
                style={{ marginLeft: "9rem" }}>
                {`${docPages}`} {selectedLanguage.LstLanguageCodes.UI_Page}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            className="res-restrirction"
            style={{ borderBottom: "0.1rem solid #e7e5e570", width: "100%" }}
            id={"trMain"}>
            <td className="text-start pages-td" style={{ fontWeight: "400" }}>
              <div className="input-group custom-inputBorder d-flex align-items-center">
                <div className="input-group-text" id="basic-addon1">
                  <div className="checkbox">
                    <label className="pl-10px">
                      <input
                        className="form-check-input notLevelOne"
                        type="checkbox"
                        style={{ marginTop: "1rem" }}
                        onChange={selectAllPagesHandler}
                        ref={selectAllRef}
                      />
                      <span className="cr">
                        <i className="cr-icon material-icons">check</i>
                      </span>
                    </label>
                    <label className="mb-0">
                      {selectedLanguage.LstLanguageCodes.UI_SelectAll}
                    </label>
                  </div>
                </div>
                <input
                  type="search"
                  className="form-control"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  placeholder={`${selectedLanguage.LstLanguageCodes.UI_Search}...`}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/\D/g, ""))
                  }
                  onChange={onSearchHandler}
                  style={{
                    boxShadow: "none",
                    padding: "8.5px 2px 8px 32px",
                    border: "none !important",
                  }}
                />
              </div>
            </td>
          </tr>
          <div className="pages-scrollbar">
            {results.length >= 5
              ? results.map((i, index) => {
                if (index % 5 === 0) {
                  return (
                    <tr
                      className="res-restrirction"
                      style={{
                        borderBottom: "0.1rem solid #e7e5e570",
                        width: "100%",
                      }}
                    >
                      <td className="text-start d-flex">
                        {results.slice(index, index + 5).map((item, iter) => {
                          return (
                            <div
                              className={`checkbox pb-2 pt-2 page-list-items`}>
                              <label
                                className="p-0 mb-0"
                                ref={(el) =>
                                  (pageNumbersRef.current[item] = el)
                                }>
                                <input
                                  type="checkbox"
                                  ref={(el) =>
                                    (selectedInputRef.current[item] = el)
                                  }
                                  onChange={selectPageHandler}
                                />
                                <span className="cr">
                                  <i className="cr-icon material-icons">
                                    check
                                  </i>
                                </span>
                                <span
                                  style={{
                                    marginLeft: "0.5rem",
                                    fontWeight: "400",
                                  }}>
                                  {item}
                                </span>
                              </label>
                            </div>
                          );
                        })}
                      </td>
                    </tr>
                  );
                }
              })
              : results.length > 0 &&
              results.map((i, index) => {
                if (index % 5 === 0) {
                  return (
                    <tr
                      key={index}
                      className="res-restriction"
                      style={{
                        borderBottom: "0.1rem solid #e7e5e570",
                        width: "100%",
                      }}>
                      <td className="text-start d-flex">
                        {[...Array(5)].map((_, iter) => {
                          const item = results[index + iter];
                          return item !== undefined ? (
                            <div
                              key={item}
                              className={`checkbox pb-2 pt-2 page-list-items ${index === 0 ? "mt" : ""
                                }`}>
                              <label className="p-0 mb-0">
                                <input
                                  type="checkbox"
                                  ref={(el) =>
                                    (selectedInputRef.current[item] = el)
                                  }
                                  onChange={selectPageHandler}
                                />
                                <span className="cr">
                                  <i className="cr-icon material-icons">
                                    check
                                  </i>
                                </span>
                                <span
                                  style={{
                                    marginLeft: "0.5rem",
                                    fontWeight: "400",
                                  }}>
                                  {item}
                                </span>
                              </label>
                            </div>
                          ) : (
                            <div
                              key={`empty-${index + iter}`}
                              className={`checkbox pb-2 pt-2 page-list-items ${index === 0 ? "mt" : ""
                                }`}></div>
                          );
                        })}
                      </td>
                    </tr>
                  );
                }
              })}
          </div>
        </tbody>
      </table>
    </div>
  );
});
export default Pages;
